export const GET_SYSTEM_PARAMETERS = "GET_SYSTEM_PARAMETERS"
export const GET_FAQ_URL = "GET_FAQ_URL"
export const GET_HOME_PAGE_TEXT = "GET_HOME_PAGE_TEXT"
export const LIST_OF_CANDIDATES_TEXT = "LIST_OF_CANDIDATES_TEXT"
export const INTRO_TEXT_CANDIDATE_DETAILS ="INTRO_TEXT_CANDIDATE_DETAILS"
export const STATE_GOVT_EMPLOYEE_LINK = "STATE_GOVT_EMPLOYEE_LINK"
export const QUALIFICATIONS_HELPTEXT = "QUALIFICATIONS_HELPTEXT"
export const SKILLS_EXPERTISE_HELPTEXT = "SKILLS_EXPERTISE_HELPTEXT"
export const CONTACT_US_PAGE_HTMLTEXT = "CONTACT_US_PAGE_HTMLTEXT"
export const DECLARATION_BODY_TEXT="DECLARATION_BODY_TEXT"
export const FAQ_FOR_GENERAL_USERS="FAQ_FOR_GENERAL_USERS"
export const FAQ_FOR_AUTHORISED_USERS="FAQ_FOR_AUTHORISED_USERS"
export const TITLE_HELPTEXT="TITLE_HELPTEXT"
export const LINKEDIN_LINK_HELPTEXT="LINKEDIN_LINK_HELPTEXT"
export const ANY_COMMENTS_HELPTEXT="ANY_COMMENTS_HELPTEXT"
export const COMMUNICATIONS_HELPTEXT='COMMUNICATIONS_HELPTEXT'
export const GOOGLE_ANALYTICS_TRACKING_CODE='GOOGLE_ANALYTICS_TRACKING_CODE'


// WEBPACK FOOTER //
// ./src/actionTypes/systemParameter.js